const TITLES = {
    1: 'Club Details',
    2: 'Club Skills',
    3: 'Club Episodes',
    4: 'Club Insights',
    5: 'Club Discussions',
    6: 'Club Schedule',
};

/**
 * Hero image for the wizard. On steps 1-6 the "Step N of 6" indicator and the
 * step title sit inside the image, where the user's eyes already are.
 */
const WizardHero = ({ step }) => {
    const title = TITLES[step];

    return (
        <div className="wizard-hero mb-3">
            <img src="/img/audience-2-wide.jpg" alt="" className="wizard-hero__img" />
            {title && (
                <div className="wizard-hero__overlay">
                    <p className="wizard-hero__eyebrow">Step {step} of 6</p>
                    <h1 className="wizard-hero__title">{title}</h1>
                </div>
            )}
        </div>
    );
};

export default WizardHero;
